<template>
 <!-- :style="{'min-height': docHt + 'px'}" -->
  <div class="wrapper">
    <div class="container">
      <img src="@/assets/images/banner.png" class="banner" />
      <div class="section">
        <p>您的申请正在审核中，请您耐心等待~</p>
        <p>预计需要1-2个工作日。</p>
        <!-- 审核通过后，会通过短信通知您，请您注意查收短信，并立即回复信息。 -->
        <!-- <p>短信由具有中华人民共和国支付业务许可公司的易宝支付为您发送。</p> -->
        <p>您也可以现在就下载管理APP。审核通过后，会为您提供全部的功能。</p>
      </div>
      <!-- <div class="section code-section">
        <van-image class="code-img"
          width="5rem"
          height="5rem"
          fit="contain"
          src="https://img01.yzcdn.cn/vant/apple-1.jpg"
          @click="toPreviewImg"
        />
        <div class="code-img"></div>
        <div class="code-info">
          <h4>下载客户端</h4>
          <p>手机扫一扫</p>
        </div>
      </div> -->
      <div class="section account-section"> 
        <div class="row" v-if="account">
          <span class="label-name">账号</span>
          <span class="account-info">{{account}}<span class="copy-btn" v-clipboard:copy="account" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span></span>
        </div>
        <div class="row" v-if="password">
          <span class="label-name">初始密码</span>
          <span class="account-info">{{password}}<span class="copy-btn" v-clipboard:copy="password" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span></span>
        </div>
      </div>
      <div class="section link-section">
        <a href="https://pc.qdsd398.com/admin" class="link-url">https://pc.qdsd398.com/admin</a>
        <span class="copy-btn" v-clipboard:copy="'https://pc.qdsd398.com/admin'" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="btn" @click="checkPay">小程序设置</div>
      <!-- <router-link :to="{path: '/store-list'}" class="btn">小程序设置</router-link> -->
      <!-- <span class="btn" @click="Toast('请您联系客服~');">小程序设置</span> -->
      <!-- <a href="https://apps.apple.com/app/id1644578076" target="_blank" class="btn upload-btn pc-upload-btn">下载客户端app</a> -->
      <!-- <a href="javascripe:void(0);" class="btn upload-btn m-upload-btn" @click="openLink">下载客户端app</a> -->
      <router-link :to="{path: '/download'}" class="btn upload-btn pc-upload-btn">下载客户端app</router-link>
      <div class="btn upload-btn m-upload-btn" @click="openLink">下载客户端app</div>
      <!-- <a href="javascripe:void(0);" class="btn upload-btn m-upload-btn" @click="openLink">下载客户端app</a> -->
    </div>
    <ContactBtn />
  </div>
</template>


<script>
import { ImagePreview } from 'vant';
import { getLoginUser, getPassword } from '@/api/user';
import { getAnnualFeeInfo } from '@/api/baseinfo';
export default {
  name: 'apply-results',
  data () {
    return {
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      shopCode: undefined,
      account: undefined,
      password: undefined
    }
  },
  created() {
    this.shopCode = this.$route.query && this.$route.query.shopCode ? this.$route.query.shopCode : undefined;
    this.getLoginUser();
    this.getPassword();
  },
  methods: {
    checkPay(){
      getAnnualFeeInfo(this.shopCode).then(res => {
        if(res.data) {
          if(res.data.appletRegisterCost&&res.data.appletRegisterCost>0){
            this.$router.push({
              path: '/payment?shopCode='+this.shopCode+'&isAppletFee=1'
            })
          } else {
            this.$router.push({
              // path: '/register-mp?shopCode='+this.shopCode
              path: '/appId?shopCode='+this.shopCode
            })
          }
        }
      })
    },
    onCopySuccess() {
      this.Toast('复制成功');
    },
    onCopyError() {
      this.Toast('抱歉，复制失败！');
    },
    getLoginUser() {
      getLoginUser().then(res => {
        if(res.code === 200) {
          this.account = res.data.userTel;
        }
      })
    },
    getPassword() {
      getPassword(this.shopCode).then(res => {
        if(res.code === 200 && res.data) {
          this.password = res.data.password;
        }
      })
    },
    openLink() {
      var ua = navigator.userAgent.toLowerCase();  
      if(ua.match(/MicroMessenger/i)=="micromessenger") {
        alert('请在浏览器打开');
      } else {
        this.$router.push({
          path: '/download'
        })
        // window.open('https://apps.apple.com/app/id1644578076');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: .05rem;
    position: relative;
  }
  .banner{
    width: 16.7rem;
    height: 8.2rem;
    display: block;
    margin: .5rem auto 1.2rem;
    border-radius: .8rem;
  }
  .section{
    width: 16.7rem;
    margin: 0 auto 1.2rem;
    p{
      line-height: 1.5;
      font-size: .7rem;
      color: #222;
      text-align: left;
      margin-bottom: .25rem;
    }
  }
  .code-section{
    background: #F5F5F7;
    border-radius: .8rem;
    padding: 1.5rem;
    box-sizing: border-box;
    @include flex-align();
    .code-img{
      width: 5rem;
      height: 5rem;
      background: #eee;
      cursor: pointer;
    }
    .code-info{
      margin-left: 1rem;
      h4{
        font-size: 1.1rem;
        font-weight: 400;
        color: #222222;
      }
      p{
        font-size: .8rem;
        color: #999999;
        margin-top: .35rem;
      }
    }
  }
  .account-section{
    .row{
      margin-bottom: .15rem;
      @include flex-align();
      .label-name{
        width: 3rem;
        font-size: .7rem;
        color: #999;
      }
      .account-info{
        margin-left: .9rem;
        font-size: .7rem;
        color: #222;
        .copy-btn{
          font-size: .7rem;
          color: $base-color;
          margin-left: .3rem;
          cursor: pointer;;
        }
      }
    }
  }
  .link-section{
    background: #F5F5F7;
    border-radius: .8rem;
    padding: 1rem .8rem;
    box-sizing: border-box;
    @include flex(space-between);
    .link-url{
      font-size: .7rem;
      color: #3780D4;
    }
    .copy-btn{
      font-size: .7rem;
      color: $base-color;
      margin-left: .3rem;
      cursor: pointer;;
    }
  }
  .footer{
    width: 16.75rem;
    height: 2.2rem;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    z-index: 3;
    .btn{
      width: 8rem;
      height: 2.2rem;
      line-height: 2.15rem;
      background: #47B6C7;
      border-radius: .4rem;
      font-size: .8rem;
      color: #fff;
      text-align: center;
      cursor: pointer;
    }
  }
  .pc-upload-btn{
    display: none;
  }
  .m-upload-btn{
    display: inline-block;
  }
}
@media screen and (min-width:750px){
  .banner{
    width: 334px;
    height: 164px;
    display: block;
    margin: 10px auto 24px;
    border-radius: 16px;
  }
  .section{
    width: 334px;
    margin: 0 auto 24px;
    p{
      line-height: 1.5;
      font-size: 14px;
      color: #222;
      text-align: left;
      margin-bottom: 5px;
    }
  }
  .code-section{
    background: #F5F5F7;
    border-radius: 16px;
    padding: 30px;
    box-sizing: border-box;
    @include flex-align();
    .code-img{
      width: 100px;
      height: 100px;
      background: #eee;
      cursor: pointer;
    }
    .code-info{
      margin-left: 20px;
      h4{
        font-size: 22px;
        font-weight: 400;
        color: #222222;
      }
      p{
        font-size: 16px;
        color: #999999;
        margin-top: 7px;
      }
    }
  }
  .account-section{
    .row{
      margin-bottom: 3px;
      @include flex-align();
      .label-name{
        width: 60px;
        font-size: 14px;
        color: #999;
      }
      .account-info{
        margin-left: 18px;
        font-size: 14px;
        color: #222;
        .copy-btn{
          font-size: 14px;
          color: $base-color;
          margin-left: 6px;
          cursor: pointer;;
        }
      }
    }
  }
  .link-section{
    background: #F5F5F7;
    border-radius: 16px;
    padding: 20px 16px;
    box-sizing: border-box;
    @include flex(space-between);
    .link-url{
      font-size: 14px;
      color: #3780D4;
    }
    .copy-btn{
      font-size: 14px;
      color: $base-color;
      margin-left: 6px;
      cursor: pointer;;
    }
  }
  .footer{
    width: 335px;
    height: 88px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    padding: 20px 0 30px;
    z-index: 3;
    .btn{
      width: 160px;
      height: 44px;
      line-height: 43px;
      background: #47B6C7;
      border-radius: 8px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      cursor: pointer;
    }
  }
  .pc-upload-btn{
    display: inline-block;
  }
  .m-upload-btn{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/apply-results.vue